'use client';

import { c as _c } from "react/compiler-runtime";
import { FulfillmentTile } from '../product-details';
import type { MiniPdpFulfillmentProps } from './model/use-mini-pdp-fulfillment';
import { useMiniPdpFulfillment } from './model/use-mini-pdp-fulfillment';
export function MiniPdpFulfillment(t0) {
  const $ = _c(11);
  const {
    product,
    tailored,
    isLoading
  } = t0;
  let t1;
  if ($[0] !== isLoading || $[1] !== product || $[2] !== tailored) {
    t1 = {
      product,
      tailored,
      isLoading
    };
    $[0] = isLoading;
    $[1] = product;
    $[2] = tailored;
    $[3] = t1;
  } else {
    t1 = $[3];
  }
  const {
    fulfillmentMethods,
    register
  } = useMiniPdpFulfillment(t1);
  let t2;
  if ($[4] !== fulfillmentMethods || $[5] !== register) {
    let t3;
    if ($[7] !== register) {
      t3 = method => <FulfillmentTile key={method.value} {...method} inputProps={register} />;
      $[7] = register;
      $[8] = t3;
    } else {
      t3 = $[8];
    }
    t2 = fulfillmentMethods.map(t3);
    $[4] = fulfillmentMethods;
    $[5] = register;
    $[6] = t2;
  } else {
    t2 = $[6];
  }
  let t3;
  if ($[9] !== t2) {
    t3 = <fieldset className="delivery-options" data-testid="mini-pdp-fulfillment-options">{t2}</fieldset>;
    $[9] = t2;
    $[10] = t3;
  } else {
    t3 = $[10];
  }
  return t3;
}